import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import Nav from './Styled/Nav'
import Header from './Styled/Header'
import { Link } from 'react-router-dom'
import Helpers from '../Helpers/Helpers'
import { useHistory } from 'react-router-dom'

const Layout = ({ page, type, children, title, permissions, companyName, folderPath, imageLogo, iconsHeader, hideTop, forCustomer, mainPage }) => {
  const resize = false
  const resizeOpen = false
  const [mobile, setMobile] = useState(false)
  const [navigation, setNavigation] = useState([])
  const [idxActive, setIdxActive] = useState(-1)
  const history = useHistory()

  useEffect(() => {
    window.document.title = title + ' - ' + companyName
  }, [title, companyName])

  useEffect(() => setMobile(false), [page])

  useEffect(() => {
    let nav = []
    let i = 0

    permissions.forEach(d => {
      /*  nav.push(<Nav.Title resizeOpen={resizeOpen} resize={resize}>
         <span>{d.parent.description}</span>
         <i className="fas fa-ellipsis-h"></i>
       </Nav.Title>) */

      d.childrens.forEach(p => {
        let childs = []
        let itemActive = false

        p.childrens.forEach(ch => {
          if (!itemActive) {
            if (idxActive === -1) {
              if (ch.a_href === 'registrar-cliente') {
              } else {
                if (ch.a_href === page) {
                  setIdxActive(i)
                }
              }
            } else {
              if (idxActive === i) {
                itemActive = true
              }
            }
          }

          if (parseInt(ch.show) === 1) {
            if (ch.a_href === 'registrar-cliente') {
              nav.push(<Nav.OneLevel.Item resizeOpen={resizeOpen} resize={resize}>
                <Nav.OneLevel.TitleContent resizeOpen={resizeOpen} resize={resize} data-idx={i} onClick={_ => {
                  history.push(Helpers.config.convertUrl({
                    url: '/' + ch.a_href
                  }))
                  setIdxActive(-1)
                }} style={{
                  backgroundColor: '#0F5969',
                  color: '#fff'
                }}>
                  <Nav.OneLevel.Title>
                    <Nav.OneLevel.Icon resizeOpen={resizeOpen} resize={resize}>
                      {type === 'FontAwesome' ? <i className="fa fa-users"></i> : ''}
                    </Nav.OneLevel.Icon>
                    <Nav.OneLevel.Description resizeOpen={resizeOpen} resize={resize}>{ch.description}</Nav.OneLevel.Description>
                  </Nav.OneLevel.Title>
                </Nav.OneLevel.TitleContent>
              </Nav.OneLevel.Item>)
            } else {
              childs.push(<Link to={Helpers.config.convertUrl({ url: '/' + ch.a_href })} style={{
                textDecoration: 'none',
                color: 'inherit'
              }}>
                <Nav.SecondLevel.Item active={page === ch.a_href}>
                  <Nav.SecondLevel.Title>
                    <Nav.SecondLevel.Icon />
                    <Nav.SecondLevel.Description resizeOpen={resizeOpen} resize={resize}>
                      {ch.description}
                    </Nav.SecondLevel.Description>
                  </Nav.SecondLevel.Title>
                </Nav.SecondLevel.Item>
              </Link>)
            }
          }
        })

        nav.push(<Nav.OneLevel.Item resizeOpen={resizeOpen} resize={resize}>
          {forCustomer ? <></> : <>
            <Nav.OneLevel.TitleContent resizeOpen={resizeOpen} resize={resize} data-idx={i} active={itemActive} onClick={e => setIdxActive(idxActive === parseInt(e.currentTarget.dataset.idx) ? -2 : parseInt(e.currentTarget.dataset.idx))}>
              <Nav.OneLevel.Title>
                <Nav.OneLevel.Icon resizeOpen={resizeOpen} resize={resize}>
                  {type === 'FontAwesome' ? <i className={p.parent.icon}></i> : ''}
                </Nav.OneLevel.Icon>
                <Nav.OneLevel.Description resizeOpen={resizeOpen} resize={resize}>{p.parent.description}</Nav.OneLevel.Description>
              </Nav.OneLevel.Title>
              <Nav.OneLevel.IconArrow resizeOpen={resizeOpen} resize={resize} active={itemActive} />
            </Nav.OneLevel.TitleContent>
          </>}

          <Nav.SecondLevel active={itemActive || forCustomer} resizeOpen={resizeOpen} resize={resize}>
            {React.Children.toArray(childs)}
          </Nav.SecondLevel>
        </Nav.OneLevel.Item>)

        i++
      })
    })

    setNavigation(nav)
  }, [permissions, type, resize, resizeOpen, idxActive, page])

  /* const breadCrumb = useMemo(() => {
    let bread = {}

    permissions.forEach(d => {
      d.childrens.forEach(p => {
        p.childrens.forEach(ch => {
          if (ch.a_href === page) {
            bread = {
              parent: d.parent.description,
              child: p.parent.description,
              current: ch.description
            }
          }
        })
      })
    })

    return <>
      {<PageWrapper.BreadCrumb.Title>{bread.parent}</PageWrapper.BreadCrumb.Title>
      <PageWrapper.BreadCrumb.Icon />}
      <PageWrapper.BreadCrumb.Title>{bread.child}</PageWrapper.BreadCrumb.Title>
      <PageWrapper.BreadCrumb.Icon />
      <PageWrapper.BreadCrumb.Title active>{bread.current}</PageWrapper.BreadCrumb.Title>
    </>
  }, [page, permissions]) */

  const enabledPages = new Set()
  permissions.forEach(group => group.childrens.forEach(section => section.childrens.forEach(item => {
    if (parseInt(item.show) === 1 || item.show === undefined) enabledPages.add(item.a_href)
  })))

  const preferredHome = mainPage && enabledPages.has(mainPage) ? mainPage : ''
  const fallbackOrder = forCustomer
    ? ['dashboard', 'ecommerce', 'mi-equipo', 'mi-cuenta', 'registrar-cliente']
    : ['clientes', 'ventas', 'productos', 'inventario', 'documentos', 'perfiles']
  const firstEnabledPage = preferredHome || fallbackOrder.find(route => enabledPages.has(route)) || Array.from(enabledPages)[0] || ''
  const customerDock = [
    [firstEnabledPage, 'fa fa-home', 'Inicio'],
    ['ecommerce', 'fa fa-shopping-bag', 'Tienda'],
    ['registrar-cliente', 'fa fa-user-plus', 'Registrar'],
    ['mi-equipo', 'fa fa-project-diagram', 'Mi red'],
    ['mi-cuenta', 'fa fa-user-circle', 'Mi cuenta']
  ]
  const operationsDock = [
    [firstEnabledPage, 'fa fa-home', 'Inicio'],
    ['clientes', 'fa fa-users', 'Clientes'],
    ['ventas', 'fa fa-shopping-bag', 'Ventas'],
    ['productos', 'fa fa-box-open', 'Productos'],
    ['inventario', 'fa fa-warehouse', 'Inventario'],
    ['reporte-ventas', 'fa fa-chart-pie', 'Reportes']
  ]
  const dockItems = (forCustomer ? customerDock : operationsDock).filter(([route], index, items) =>
    route && (index === 0 || enabledPages.has(route)) && items.findIndex(item => item[0] === route) === index
  )
  const topItems = forCustomer
    ? [[firstEnabledPage, 'Resumen'], ['mi-equipo', 'Mi red'], ['mi-cuenta', 'Mi cuenta']]
    : [[firstEnabledPage, 'Inicio'], ['ventas', 'Operación'], ['reporte-ventas', 'Reportes']]
  const visibleTopItems = topItems.filter(([route], index, items) => route && (index === 0 || enabledPages.has(route)) && items.findIndex(item => item[0] === route) === index)

  return <div className="mac-app-shell mac-app-shell--live">
    <header className="mac-topbar">
      <Link className="mac-brand" to={Helpers.config.convertUrl({ url: `/${firstEnabledPage}` })}>
        <span className="mac-brand__mark">SD</span>
        <div><strong>System Devs</strong><small>Panel de control</small></div>
      </Link>
      <nav className="mac-topnav">
        {visibleTopItems.map(([route, label]) => <Link key={route} className={page === route ? 'is-active' : ''} to={Helpers.config.convertUrl({ url: `/${route}` })}>{label}</Link>)}
      </nav>
      <div className="mac-top-actions">
        {React.Children.toArray(iconsHeader.map(i => <div className="mac-top-action-item">{i}</div>))}
        <button type="button" className="mac-menu-trigger" onClick={() => setMobile(true)} aria-label="Abrir menú"><i className="fa fa-th" /></button>
      </div>
    </header>

    <main className="mac-main mac-functional-main">
      {!hideTop && <section className="mac-page-heading">
        <div><span className="mac-eyebrow">SYSTEM DEVS · ESPACIO DE TRABAJO</span><h1>{title || 'Panel principal'}</h1><p>Consulta información, completa tareas y toma decisiones desde un solo lugar.</p></div>
        <div className="mac-page-status"><i className="far fa-calendar-check" /><span>Actividad actualizada</span></div>
      </section>}
      <div className={hideTop ? 'mac-module mac-module--full' : 'mac-module'}>{children}</div>
    </main>

    <nav className="mac-dock-wrap" aria-label="Navegación principal">
      <div className="mac-dock">
        {dockItems.map(([route, icon, label], index) => <React.Fragment key={route}>
          {index === dockItems.length - 1 && dockItems.length > 4 && <span className="mac-dock__divider" />}
          <Link className={page === route ? 'is-active' : ''} to={Helpers.config.convertUrl({ url: `/${route}` })} title={label}>
            <span><i className={icon} /></span><small>{label}</small>
          </Link>
        </React.Fragment>)}
        <button type="button" title="Más" onClick={() => setMobile(true)}><span><i className="fa fa-th" /></span><small>Más</small></button>
      </div>
    </nav>

    <div className={mobile ? 'mac-menu-backdrop is-open' : 'mac-menu-backdrop'} onClick={() => setMobile(false)} />
    <aside className={mobile ? 'mac-menu-drawer is-open' : 'mac-menu-drawer'}>
      <div className="mac-menu-drawer__head">
        <a className="system-devs-drawer-brand" href={folderPath}><span>SD</span><strong>System Devs</strong></a>
        <button type="button" onClick={() => setMobile(false)} aria-label="Cerrar menú"><i className="fa fa-times" /></button>
      </div>
      <div className="mac-menu-drawer__label">TODOS LOS MÓDULOS</div>
      <Nav.OneLevel>{React.Children.toArray(navigation)}</Nav.OneLevel>
    </aside>
  </div>
}

Layout.defaultProps = {
  type: 'FontAwesome',
  page: '',
  showBread: true,
  permissions: [],
  companyName: '',
  folderPath: '',
  imageLogo: '',
  iconsHeader: [],
  resizeNav: false,
  hideTop: false,
  mainPage: ''
}

Layout.propTypes = {
  page: PropTypes.string,
  logo: PropTypes.string,
  type: PropTypes.oneOf(['FontAwesome']),
  title: PropTypes.string,
  showBread: PropTypes.bool,
  permissions: PropTypes.array,
  companyName: PropTypes.string,
  folderPath: PropTypes.string,
  imageLogo: PropTypes.string,
  iconsHeader: PropTypes.array,
  resizeNav: PropTypes.bool,
  mainPage: PropTypes.string
}

export { Layout, Header }
